<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Controls</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (controlVoltageSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Voltage:</label>
            <select
              class="halfWidthInputField"
              #controlVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlVoltageSelection.Name)"
              (change)="selectionChanged(controlVoltageSelection, controlVoltageInput.value)"
              [value]="controlVoltageSelection.Value.toString()">
              @for (allowable of controlVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="controlVoltageSelection.Value && controlVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (condensateSwitchSelection) {
          <span class="halfWidthConfigurationInput">
            <label
              [class.invalidConfigurationSelection]="isInvalidSelection(condensateSwitchSelection.Name)"
              for="condensateSwitchInput"
              class="halfWidthInputLabel">
              Condensate Switch
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="condensateSwitchInput"
              #condensateSwitchInput
              [checked]="'true' === condensateSwitchSelection.Value"
              (change)="selectionChanged(condensateSwitchSelection, condensateSwitchInput.checked.toString())" />
          </span>
        }
      </div>
    </div>
  }
</div>
